import { useEffect } from 'react';
import { TabTypes } from './constants';

type UseDefaultTabParams = {
  canModify: boolean,
  changeTab: (tab: TabTypes) => void,
  activeTab: string,
  defaultTab?: TabTypes,
}

export const useDefaultTab = ({
  canModify,
  changeTab,
  activeTab,
  defaultTab = TabTypes.VIEW,
}: UseDefaultTabParams) => {
  useEffect(() => {
    if (!canModify && activeTab !== defaultTab) {
      changeTab(defaultTab);
    }
  }, [changeTab, activeTab, canModify, defaultTab]);
};
